import type { InstallmentDto, SubscriptionDetailDto } from '../../domain/contracts/api.contracts';
import { apiClient } from './apiClient';
import { normalizeMoney } from './wireAdapters';

/** E07 — GET /subscriptions/my */
export async function getMySubscription(): Promise<SubscriptionDetailDto> {
  const { data } = await apiClient.get<SubscriptionDetailDto>('/subscriptions/my');
  return normalizeMoney(data);
}

/** E08 — GET /subscriptions/:id/installments (404 on foreign ids). */
export async function getInstallments(subscriptionId: string): Promise<InstallmentDto[]> {
  const { data } = await apiClient.get<InstallmentDto[]>(`/subscriptions/${subscriptionId}/installments`);
  return normalizeMoney(data);
}
